export const calculateDistance = (
  object1: { x: number; y: number },
  object2: { x: number; y: number },
): number =>
  Math.sqrt(
    Math.pow((object2.x as number) - (object1.x as number), 2) +
      Math.pow((object2.y as number) - (object1.y as number), 2),
  );
